export default function MySQL_GREATEST() {
  return (
    <div>
      <h2>MySQL_GREATEST</h2>    </div>
  );
}